var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('div',{staticClass:"tw-z-1 tw-flex tw-flex-col tw-justify-center tw-items-center tw-pointer-events-none"},[_c('v-progress-circular',{attrs:{"color":_vm.color,"indeterminate":""}}),_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }